import completed from './completed.svg';
import negative from './negative.svg';
import positive from './positive.svg';

export const images = { completed, negative, positive };
